export const TourStatus = {
  COMING_PREPARATORY: 'coming_preparatory',
  PREPARATORY: 'preparatory',
  COMING_TRIAL: 'coming_trial',
  TRIAL: 'trial',
  COMING_MAIN: 'coming_main',
  MAIN: 'main',
  COMING_FINAL: 'coming_final',
  FINAL: 'final',
  FINISH: 'finish',
}

export const TourName = {
  [TourStatus.COMING_PREPARATORY]: 'Preparatory',
  [TourStatus.PREPARATORY]: 'Preparatory',
  [TourStatus.COMING_TRIAL]: 'Warm-Up Stage',
  [TourStatus.TRIAL]: 'Warm-Up Stage',
  [TourStatus.COMING_MAIN]: 'DinoMath Olympiad',
  [TourStatus.MAIN]: 'DinoMath Olympiad',
  [TourStatus.COMING_FINAL]: 'Final Round',
  [TourStatus.FINAL]: 'Final Round',
  [TourStatus.FINISH]: 'Finish',
}

export function getTourStatus(event) {
  const currentTime = new Date();

  const preparatoryTourStartsAt = new Date(event.preparatory_tour_starts_at);
  const preparatoryTourEndsAt = new Date(event.preparatory_tour_ends_at);
  const trialTourStartsAt = new Date(event.trial_tour_starts_at);
  const trialTourEndsAt = new Date(event.trial_tour_ends_at);
  const mainTourStartsAt = new Date(event.main_tour_starts_at);
  const mainTourEndsAt = new Date(event.main_tour_ends_at);
  const finalTourStartsAt = event.final_tour_starts_at ? new Date(event.final_tour_starts_at) : null;
  const finalTourEndsAt = event.final_tour_ends_at ? new Date(event.final_tour_ends_at) : null;

  if (currentTime < preparatoryTourStartsAt) {
    return TourStatus.COMING_PREPARATORY;
  } else if (currentTime >= preparatoryTourStartsAt && currentTime <= preparatoryTourEndsAt) {
    return TourStatus.PREPARATORY;
  } else if (currentTime > preparatoryTourEndsAt && currentTime < trialTourStartsAt) {
    return TourStatus.COMING_TRIAL;
  } else if (currentTime >= trialTourStartsAt && currentTime <= trialTourEndsAt) {
    return TourStatus.TRIAL;
  } else if (currentTime > trialTourEndsAt && currentTime < mainTourStartsAt) {
    return TourStatus.COMING_MAIN;
  } else if (currentTime >= mainTourStartsAt && currentTime <= mainTourEndsAt) {
    return TourStatus.MAIN;
  } else {
    if (finalTourStartsAt && finalTourEndsAt) {
      if (currentTime < finalTourStartsAt) {
        return TourStatus.COMING_FINAL;
      } else if (currentTime >= finalTourStartsAt && currentTime <= finalTourEndsAt) {
        return TourStatus.FINAL;
      }
    }
    return TourStatus.FINISH;
  }
}
